/**
 * Entry point — wraps the app in the router and the OIDC provider.
 *
 * The OIDC configuration (storage, PKCE, refresh, callback-URL rewrite) lives in
 * `./oidc.ts` as a pure, unit-tested factory (`buildOidcConfig`) so the
 * security-critical settings are verified without bootstrapping React. 2FA is
 * handled entirely by Zitadel on the /callback redirect — the SPA never sees
 * credentials or OTP codes (ARCHITECTURE §7).
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { buildOidcConfig } from "./oidc";
import "./styles/tokens.css";
import "./styles/app.css";

const oidcConfig = buildOidcConfig();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container #root not found");
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider {...oidcConfig}>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
